module.exports = __webpack_public_path__ + "img/webcam.e49f4fdc.svg";